import { Badge, Box } from '@mui/material'
import React, { useRef, useState } from 'react'
import { BellIcon } from 'Sui_Icons'
import { convertToPersianNumber } from 'utils'
import { NotificationDetail } from './NotificationDetail'

export const Notifications = ({infoUser}) => {

    const anchorEl = useRef()
    const [detailVisiblity, setDetailVisiblity] = useState(false)

    const numberOfNotifications = infoUser.notification ? infoUser.notification : 0

    return (
        <>
            <Box sx={{ ml: 4, cursor: 'pointer' }} ref={anchorEl} >
                <Badge
                    onClick={() => setDetailVisiblity(!detailVisiblity)}
                    badgeContent={convertToPersianNumber(numberOfNotifications)}
                    color='warning'
                    sx={{
                        '& .MuiBadge-badge': {
                            mt: { xs: 1, lg: 'unset' }
                        }
                    }}

                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }} >
                    <BellIcon size={'40px'} sx={{ filter: { lg: 'drop-shadow(0px 10px 14px #e2e2e2)' } }} />
                </Badge>
            </Box>
            <NotificationDetail open={numberOfNotifications == 0 ? null : detailVisiblity} setOpen={numberOfNotifications == 0 ? null : setDetailVisiblity} anchorEl={anchorEl.current} />
        </>
    )
}
